export default function getEnvVarByName(varName: string): string {
  return process.env[`REACT_APP_${varName}`] || ''
}
